import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { AllowedNamespace } from '@modules/permissions/types';

const useNamespaceStore = defineStore('namespace', () => {
  const namespace = ref<AllowedNamespace>();

  function setNamespace(value: AllowedNamespace | undefined): void {
    namespace.value = value;
  }

  return {
    namespace,
    setNamespace,
  };
});

export default useNamespaceStore;
